import { useState } from 'react';
import { CameraFeed } from './components/Camera/CameraFeed';
import { TextDisplay } from './components/Output/TextDisplay';
import { SpeechSynthesis } from './components/Output/SpeechSynthesis';
import { ParticleSystem } from './components/Visualization/ParticleSystem';
import { CustomGestureTrainer } from './components/GestureRecognition/CustomGestureTrainer';
import { Settings } from './components/UI/Settings';
import { useAppStore } from './store/appStore';
import './App.css';

function App() {
  const { clearHistory, currentEmotion, customGestures } = useAppStore();
  const [activeTab, setActiveTab] = useState<'main' | 'trainer' | 'settings'>('main');

  return (
    <div className="app">
      <header className="app-header">
        <h1>AIX-Sync</h1>
        <p className="subtitle">Artificial Intelligence Experience Synchronization - Phase 2</p>
        <nav className="app-nav">
          <button 
            className={activeTab === 'main' ? 'active' : ''}
            onClick={() => setActiveTab('main')}
          >
            Main
          </button>
          <button 
            className={activeTab === 'trainer' ? 'active' : ''}
            onClick={() => setActiveTab('trainer')}
          >
            Custom Gestures ({customGestures.length})
          </button>
          <button 
            className={activeTab === 'settings' ? 'active' : ''}
            onClick={() => setActiveTab('settings')}
          >
            Settings
          </button>
        </nav>
      </header>

      <main className="app-main">
        {activeTab === 'main' && (
          <>
            <div className="left-panel">
              <CameraFeed />
              <SpeechSynthesis />
              {currentEmotion && (
                <div className="emotion-display">
                  <h3>Emotion Detected</h3>
                  <p className="emotion-name">{currentEmotion.emotion}</p>
                  <p className="emotion-confidence">
                    {(currentEmotion.confidence * 100).toFixed(0)}% confident
                  </p>
                </div>
              )}
            </div>

            <div className="center-panel">
              <ParticleSystem />
            </div>

            <div className="right-panel">
              <TextDisplay />
              <button 
                onClick={clearHistory}
                className="btn btn-secondary clear-btn"
              >
                Clear History
              </button>
            </div>
          </>
        )}

        {activeTab === 'trainer' && (
          <div className="full-panel">
            <CustomGestureTrainer />
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="full-panel">
            <Settings />
          </div>
        )}
      </main>

      <footer className="app-footer">
        <p>Phase 2 - Enhanced Recognition & Personalization</p>
        <p className="tech-stack">
          20+ Gestures • Emotion Detection • Custom Training • User Profiles
        </p>
      </footer>
    </div>
  );
}

export default App;
